module.exports = __webpack_public_path__ + "img/about_cooperation.d0b3ca7f.png";